export class SchoolVM {
    id: any;
    name?: string;
    degree?: string;
    yearGraduated?: string;
    position?: number;
    runPublishingValidators?: boolean;
  }
  